import React, { useCallback, useRef } from "react";
// styles
import { OverTable, styles } from "./styles";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import DynamicInput from "components/DynamicInput/DynamicInput";

// @material-ui/icons
import Search from "@material-ui/icons/Search";
import { useDispatch } from "react-redux";
import { useTimer } from "hooks/useTimer";

import { setSearch } from "redux/ducks/mapPage";

const useStyles = makeStyles(styles);

const OverTableSearch = () => {
  const inputRef = useRef();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [runTimer] = useTimer(800);

  const setSearchCall = useCallback(
    (search) => {
      dispatch(setSearch(search));
    },
    [dispatch]
  );

  const handleSearch = useCallback(
    (event) => {
      runTimer(setSearchCall, [event.target.value]);
    },

    [setSearchCall, runTimer]
  );
  return (
    <OverTable key="mapSearch">
      <DynamicInput
        id="material"
        color="info"
        ref={inputRef}
        formControlProps={{
          fullWidth: true,
          className: classes.noPaddingTop,
        }}
        inputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search />
            </InputAdornment>
          ),

          onKeyDown: handleSearch,

          color: "secondary",
          placeholder: "Buscar...",
        }}
      />
    </OverTable>
  );
};

export default React.memo(OverTableSearch);
